export const ru = {
    name: 'ru',
    options: {
        months: ['Январь', 'Февраль', 'Матр', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрт', 'Октябрь', 'Ноябрь', 'Декабрь'],
        shortMonths: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        days: ['Воскресение', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        toolbar: {
            download: 'Скачать SVG',
            zoomIn: 'Приблизить',
            zoomOut: 'Отдалить',
            reset: 'Сброс приближения',
        }
    }
}